<template>
  <div class="interaction-files__dropzone">
    <BasePreloader v-if="pending"/>
    <div @click="$refs.fileInput.click()"
         ref="dropzone"
         :class="{'_drag-over': dragoverMixin}"
         class="interaction-files__dropzone-btn">
      <input ref="fileInput"
             class="d-none"
             type="file"
             multiple
             @change="onFilesInputMixin">
      <BaseSvg name="ico-plus"
               height="2.7rem"/>
      <span>{{ $tInteraction('Upload') }}</span>
    </div>
  </div>
</template>

<script>
  import fileUploadMixin from '@/mixins/fileUploadMixin'

  export default {
    name: 'InteractionFilesDropzone',
    mixins: [fileUploadMixin],
    props: {
      pending: Boolean
    },
    data() {
      return {
        uploadFileMethodNameMixin: ['onUploadFiles'],
      }
    },
    methods: {
      async onUploadFiles(files) {
        this.$emit('upload', files)
      },
    },

    watch: {
      errorMixin(error) {
        this.$emit('error', error)
      }
    }
  }
</script>

<style lang="less">

</style>